export enum CurrencyEnum {
  EUR = 'EUR',
  CHF = 'CHF',
  USD = 'USD',
  RON = 'RON'
}
